<svelte:options accessors/>
<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import {getFormatter} from "../../../utils";
    import NauiDatePicker from "../../../naui/atoms/NauiDatePicker.svelte";
    import NauiSelect from "../../../naui/atoms/NauiSelect.svelte";
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";
    import NauiSwitch from "../../../naui/atoms/NauiSwitch.svelte";
    import NauiInput from "../../../naui/atoms/NauiInput.svelte";
    import {QuoteWarehouse} from "../../../classes/quote-warehouse";
    import NauiTag from "../../../naui/atoms/NauiTag.svelte";
    import NauiSlideOver from "../../../naui/layout/NauiSlideOver.svelte";
    import NauiTable from "../../../naui/components/NauiTable.svelte";
    import Galeria from "../Galeria.svelte";

    export let data;
    export let sites;
    export let insurances;
    export let date;
    export let lockValue;

    let openSlideoverImagenes;
    let tabsImagenes = [];

    let dispatch = createEventDispatcher();
    let formatter = getFormatter();
    let open = false;

    let dateObj: Date;
    let storageData: Array<QuoteWarehouse> = []

    let format = getFormatter();

    $: total = calcTotal(storageData);
    $: subtotal = calcTotal(storageData, true);

    $: labelSubtotal = `Subtotal sin IVA | ${formatter(subtotal)}`;
    $: labelTotal = `Subtotal con IVA | ${formatter(total)}`;

    onMount(() => {
        dateObj = new Date(date);
        const sd = [];
        for (const entry of data) {
            const newStorage = new QuoteWarehouse(sites, insurances, lockValue, dateObj);
            newStorage.setData(entry);
            sd.push(newStorage);
        }
        storageData = sd;
    });

    const noSizeOptions = [{
        label: 'Seleccione tamaño', value: null
    }];

    function removeStorage(index) {
        storageData.splice(index, 1);
        storageData = storageData;
    }

    function addStorage() {
        storageData = [...storageData, new QuoteWarehouse(sites, insurances, lockValue, dateObj)];
    }

    function updateDate() {
        dateObj.setTime(new Date(date).getTime())
        storageData = storageData;
    }

    function showImages() {
        openSlideoverImagenes = true
    }

    function calcTotal(sd: Array<QuoteWarehouse>, noTax = false) {
        let total = 0;
        for (const d of sd) {
            total += noTax ? d.subtotal : d.total;
        }
        return total
    }

    function save() {
        const jsonData = storageData.map(s => s.getJson());
        dispatch('save', {data: jsonData, date: date});
    }
</script>

<div class="box-l sx-15">
    <div class="max-w-400px py-15">
        <NauiDatePicker label="Fecha de inicio del servicio" bind:value={date} on:input={updateDate}/>
    </div>
    <div class="grid grid-4 gap-ii">
        <NauiButton on:click={() => {open = true}} caption="AGREGAR A LA COTIZACIÓN" mode="stroked" icon="plus"/>
        <NauiButton on:click={showImages} caption="VER IMAGES DEL SERVICIO" icon="image" mode="accent"/>
        <NauiTag label={labelSubtotal}/>
        <NauiTag label={labelTotal}/>
    </div>
</div>
<div>
    <hr>
</div>
<div class="w-100">
    {#each storageData as storage, index}
        <div class="box-l sx-1 max-w-400px mb-15">
            <NauiSelect options={sites}
                        bind:value={storage.siteId}
                        label="Sede de la bodega"/>
            <NauiButton on:click={() => {removeStorage(index);}} caption="Borrar" mode="accent"/>
        </div>
        {#if storage.site}
            <div class="grid-2 gap-1 max-w-800px mb-15">
                <NauiSelect options={storage.site.sizes}
                            label="Tamaño de bodega"
                            bind:value={storage.sizeId}/>
                {#if storage.size}
                    <NauiSelect options={storage.size.warehouses}
                                label="Seleccionar bodega"
                                bind:value={storage.warehouseId}/>
                {:else}
                    <NauiSelect options={noSizeOptions}
                                label="Seleccionar bodega"
                                bind:value={storage.warehouseId}/>
                {/if}
                <div class="box-l sx-1">
                    <div>Valor bodega:</div>
                    <div>{storage.size ? storage.totalLabel : 'Seleccionar tamaño'}</div>
                </div>
                <div class="box-l sx-1">
                    <div>Incluir candado ({format(lockValue)}):</div>
                    <NauiSwitch bind:active={storage.lock}/>
                </div>
                <div class="box-l sx-1">
                    <div>Cantidad de meses:</div>
                    <div class="box-l sx-1">
                        <NauiButton icon="minus-circle" color="accent"
                                    on:click={() => {storage.months = Math.max(storage.months - 1, 1)}}/>
                        <NauiInput label="Meses" bind:value={storage.months}/>
                        <NauiButton icon="plus-circle" color="accent"
                                    on:click={() => {storage.months = storage.months + 1}}/>
                    </div>
                </div>
                <div class="box-l sx-1">
                    <NauiSelect label="Valor del seguro" options={insurances}
                                bind:value={storage.insuranceId}/>
                </div>
                <div class="col-2 p-1 border">
                    <h3 class="mb-1">Descuento especial</h3>
                    <div class="grid-2 gap-1">
                        <NauiInput type="number" label="Valor M3 (IVA Incluido)" bind:value={storage.discount}/>
                        <NauiInput label="Valor por mes" isDisabled=true bind:value={storage.m3Discount}/>
                    </div>
                </div>
            </div>
        {/if}
        <hr>
    {/each}
    <div class="box-l sx-1">
        <NauiButton on:click={addStorage} caption="Agregar bodega" mode="accent"/>
        <NauiButton on:click={() => {open = true}} caption="AGREGAR A LA COTIZACIÓN" mode="stroked" icon="plus"/>
    </div>
</div>
<Galeria {openSlideoverImagenes} {tabsImagenes}/>
<NauiSlideOver title="TOTAL BODEGAJE" maxWidth="400px" bind:open={open}>
    {#each storageData as storage}
        {#if storage.size && storage.months > 0}
            <NauiTable data={storage.getSummary()} columns={storage.getSummaryColumns()}/>
        {/if}
    {/each}
    <div class="py-15">
        <h2 class="accent text-c w-100">{labelSubtotal}</h2>
        <h2 class="accent text-c w-100">{labelTotal}</h2>
    </div>
    <NauiButton on:click={save}
                color="accent"
                mode="solid"
                caption="AGREGAR A LA COTIZACIÓN"/>
</NauiSlideOver>
